import {CheckCircleOutlined, LoadingOutlined, WarningTwoTone} from '@ant-design/icons';
import {Button, Col, Row, Tooltip} from 'antd';
import Title from 'antd/lib/typography/Title';
import {Component} from 'react';
import {connect} from "react-redux";
import {initPreviewForScan} from "../../../redux_actions/preview_status.action";
import {cassetteType} from '../../../utils/const';


class LoadSlidesPrompt extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.previews == undefined && this.props.previews) {
            this.props.dispatch(initPreviewForScan());
        }
    }

    render() {
        return (
            <Row className="rounded-container load-slides-message-div">
                {this.props.detectingCassette ?
                    <Col className="scan-workflow-init" span={24}>
                        <Row style={{fontSize: 20}} className="arial-font">
                            <div>
                                <Row><LoadingOutlined/></Row>
                                <Row>
                                    <Title level={3}>Detecting Cassette</Title>
                                </Row>
                                <br/>
                                <Row>
                                    Please wait for a few seconds.
                                </Row>
                            </div>
                        </Row>
                    </Col>
                    : this.props.askUserCassetteType ?
                        <Col className="scan-workflow-init" span={24}>
                            <Row style={{fontSize: 20}} className="arial-font">
                                <div>
                                    <Row>
                                        <Title level={3}>Which Cassette have you inserted?</Title>
                                    </Row>
                                    <br/>
                                    <Row>Please make sure the Cassette Type is correct.</Row>
                                    <Row><WarningTwoTone twoToneColor="#FFA400"/> A mismatch can lead to slide, cassette
                                        or scanner damage.</Row>
                                    <br/>
                                    <Row>
                                        <Button onClick={(e) => {
                                            e.stopPropagation();
                                            this.props.setCassetteType(cassetteType.SIX_1_BY_3_SLIDES);
                                        }}>1x3 Slides Cassette</Button>
                                        <Button onClick={(e) => {
                                            e.stopPropagation();
                                            this.props.setCassetteType(cassetteType.TWO_2_BY_3_SLIDES);
                                        }}>2x3 Slides Cassette</Button>
                                    </Row>
                                </div>
                            </Row>
                        </Col>
                        :
                        <Col className="scan-workflow-init" span={24}>
                            <Row style={{fontSize: 20}} className="arial-font">
                                <div>
                                    <Row>
                                        Please insert slides in the Cassette
                                    </Row>
                                    <Row>
                                        and
                                    </Row>
                                    <Row>
                                        Place the Cassette back in the slot.
                                    </Row>
                                </div>
                            </Row>
                            <br></br>
                            <br></br>
                            <Row style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                <Tooltip title="Click here when done" placement="rightTop">
                                    <Col span={4} className="promt-done-button" onClick={(e) => {
                                        e.stopPropagation();
                                        this.props.handleProgressChange(1);
                                    }}>
                                        <Row style={{color: "#26A65B"}}>
                                            <CheckCircleOutlined style={{fontSize: 50}}/>
                                        </Row>
                                        <Row className="arial-font">Done</Row>
                                    </Col>
                                </Tooltip>
                            </Row>
                        </Col>
                }
            </Row>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        previews: state.previewStatusReducer,
    };
};

export default connect(mapStateToProps)(LoadSlidesPrompt);